<template>
	<div class="flex align-items credit-card">
		<div class="small-margin-right">

			<img v-if="type == 'visa'" src="https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/visa-512.png" />
			<img v-if="type == 'mastercard'" src="https://cdn2.iconfinder.com/data/icons/credit-cards-6/156/mastercard-256.png" />

		</div>
		<div>
			{{ number }}
		</div>
	</div>
</template>

<script>
export default {
  props: [
    'type',
    'number'
  ]
}
</script>

<style lang="less" scoped>
	.credit-card {
		img {
			max-width: 70px;
			max-height: 50px;
		}
	}
</style>
